// phonics_data_lt12.js
// Letter Teams L12 - L12 Long Vowel Sounds oa, ow
// 路由：/phonics/lt12

const MEDIA_BASE = '/media/phonics/lt12';
const V = 'v1';

export const letterDataLt12 = {
  id: 'lt12',
  letter: 'L12',
  title: 'L12 Long Vowel Sounds oa, ow',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals are at the stream.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Pink sees a bowl.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "The bowl floats in the stream.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Let's have a boat race!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "We can race to the goal.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Pink and Blue get in boats.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Go!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Pink and Blue row the boats.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "You are too slow!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "I cannot row!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "There is the goal!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Oh! Look at the crow!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "The crow has a bow!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Blue's team wins!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "What do we win?", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Your prize is some toast!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "Yay!", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
